export const TEXT_REPORT_MAX_LENGTH = 20000;

export function isTextReport(file: any): boolean {
  if (!file) {
    return false;
  }

  const kind = String(file?.kind || '').toLowerCase();
  const fileType = String(file?.type || '').toLowerCase();

  return kind === 'text' || fileType === 'text/plain';
}

export function getTextReportBody(file: any): string {
  return String(file?.text || '').trim();
}

export function getTextReportPreviewSource(file: any): string {
  const preview = String(file?.text_preview || '').trim();
  if (preview) {
    return preview;
  }

  return getTextReportBody(file);
}

export function getTextReportExcerpt(file: any, maxLength = 140): string {
  const body = getTextReportPreviewSource(file).replace(/\s+/g, ' ');

  if (!body) {
    return 'Empty text report';
  }

  if (body.length <= maxLength) {
    return body;
  }

  return `${body.slice(0, maxLength).trim()}…`;
}

export function getTextReportLineCount(file: any): number {
  const body = getTextReportBody(file);

  if (body) {
    const lines = body.split(/\r?\n/).filter((line) => line.trim());
    return lines.length || 1;
  }

  const length = Number(file?.text_length || 0);
  if (length > 0) {
    return Math.max(1, Math.ceil(length / 80));
  }

  return 0;
}

export function getTextReportCharCount(value: string): number {
  return String(value ?? '').length;
}

export function isTextReportOverLimit(
  value: string,
  maxLength = TEXT_REPORT_MAX_LENGTH,
): boolean {
  return getTextReportCharCount(value) > maxLength;
}

export function formatTextReportCounter(
  current: number,
  maxLength = TEXT_REPORT_MAX_LENGTH,
): string {
  return `${current.toLocaleString()} / ${maxLength.toLocaleString()} characters`;
}

export function canOpenTextReport(file: any): boolean {
  if (!isTextReport(file)) {
    return false;
  }

  if (getTextReportBody(file)) {
    return true;
  }

  return Number(file?.text_length || 0) > 0 || Number(file?.id || 0) > 0;
}
